import { LocalStorage } from '../types/common'
import { KEY_DATA_USER_LS } from '../constants/constantsApp'

export const getLocalStorage = (key: string) => {
  if (typeof localStorage != 'undefined') {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
  }
  return {}
}

export const setLocalStorage = (key: string, data: unknown) => {
  return window.localStorage.setItem(key, JSON.stringify(data))
}

export const getSessionStorage = (key: string) => {
  if (typeof sessionStorage != 'undefined') {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : null
  }
  return {}
}

export const setSessionStorage = (key: string, data: unknown) => {
  return window.sessionStorage.setItem(key, JSON.stringify(data))
}

export const saveDataLeadLocalStorage = (identification: string, name: string, email: string, phone: string) => {
  const keyLocalStorage = KEY_DATA_USER_LS

  const data: LocalStorage[] = getLocalStorage(keyLocalStorage) || []
  const dataValidate = data.find((item) => item.identification === identification)

  if (!dataValidate) {
    const updatedData = [
      ...data,
      {
        identification,
        name,
        email,
        phone,
      },
    ]
    setLocalStorage(keyLocalStorage, updatedData)
  }
}

export const loadDataLeadLocalStorage = (identification: string) => {
  const data: LocalStorage[] = getLocalStorage(KEY_DATA_USER_LS)
  return !!data && data.find((item) => item.identification === identification)
}
